import _ from 'lodash';
import isObject from './isObject.js';
import mergeObject from './mergeObject.js';
import removeDirectives from './removeDirectives.js';

const mergeArray = (a, b) => {
  if (_.isUndefined(b)) return a;
  if (_.isNull(b)) return null;
  if (_.isEmpty(b)) return getIdentityKey(_.get(a, 0)) ? a : b;
  if (_.some(b, item => _.has(item, '$replace') && Object.keys(item).length === 1)) {
    return _.filter(b, item => !_.has(item, '$replace')).map(removeDirectives);
  }
  if (_.some(b, { $append: true })) return _.reject([...a, ...b], item => item.$append);
  if (_.isArray(_.head(b)) && !_.isEmpty(_.head(b))) {
    return _.map(b, (item, index) => mergeArray(_.get(a, index), item));
  }
  if (_.some(b, item => !getIdentityKey(item))) return b;

  const array = _.isArray(a) ? a.filter(item => getIdentityKey(item)) : [];

  // On doit traiter les $remove en premier pour être sur que les $index seront respectés.
  _.filter(b, { $remove: true }).forEach(item => {
    const identityKey = getIdentityKey(item);
    const index = _.findIndex(array, { [identityKey]: item[identityKey] });
    if (index !== -1) {
      array.splice(index, 1);
    }
  });

  _.forEach(b, item => {
    const identityKey = getIdentityKey(item);
    const index = _.findIndex(array, { [identityKey]: item[identityKey] });

    if (item.$remove) {
      // déjà traité
    } else if (
      _.has(item, '$index') &&
      item.$index !== index &&
      item.$index >= 0 &&
      item.$index < array.length
    ) {
      if (index === -1) {
        array.splice(item.$index, 0, removeDirectives(_.omit(item, ['$index'])));
      } else {
        const itemA = array[index];
        array.splice(index, 1);
        array.splice(item.$index, 0, mergeObject(itemA, _.omit(item, ['$index'])));
      }
    } else if (index !== -1) {
      array[index] = mergeObject(array[index], _.omit(item, ['$index']));
    } else {
      array.push(removeDirectives(item));
    }
  });

  return array;
};

export default mergeArray;

const getIdentityKey = obj => {
  if (!isObject(obj)) return null;
  return _.find(['id', 'key', 'name'], key => _.has(obj, key) && obj[key] !== '$remove');
};
